export const ADDED_NEW_NOTIFICATION_SUCCESS = 'ADDED_NEW_NOTIFICATION_SUCCESS'
export const SET_CLEAR_NOTIFICATION = 'SET_CLEAR_NOTIFICATION'